import classnames from 'classnames';
import React from 'react';
import Avatar from '../../core/Avatar';
import Chip from '../../core/Chip';
import Divider from '../../core/Divider';
import Grid from '../../core/Grid';
import Icon from '../../core/Icon';
import Link from '../../core/Link';
import StatusLabel from '../../core/StatusLabel';
import Text from '../../core/Text';
import TextField from '../../core/TextField';
import Tooltip from '../../core/Tooltip';
import Tokens from '../../core/styles/Tokens';
import { createStyles, withStyles } from '../../core/styles/withStyles';
const styles = (theme) => createStyles({
    anchorIcon: {
        '&:focus': {
            '& *': {
                backgroundColor: 'transparent'
            }
        }
    },
    centered: {
        alignItems: 'center',
        display: 'flex'
    },
    chatContainer: {
        display: 'block!important',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: Tokens.spacing40,
        width: 'auto'
    },
    chatContainerScroll: {
        maxHeight: '200px'
    },
    chatTitle: {
        backgroundColor: Tokens.colorBrandNeutral200,
        boxShadow: '0 0 1.25rem rgba(0, 0, 0, .1)',
        height: '57px',
        padding: Tokens.spacing40
    },
    chipCommonComments: {
        backgroundColor: Tokens.colorBrandNeutral100,
        borderWidth: 0,
        boxShadow: '0 0 1.25rem rgba(0, 0, 0, .1)',
        marginBottom: Tokens.spacing40
    },
    chipEditableComments: {
        '& > span': {
            [theme.breakpoints.down('md')]: {
                display: 'block',
                textAlign: 'right'
            }
        },
        backgroundColor: Tokens.colorBrandNeutral100,
        borderWidth: 0,
        boxShadow: '0 0 1.25rem rgba(0, 0, 0, .1)',
        marginBottom: Tokens.spacing40
    },
    chipImportantComments: {
        backgroundColor: Tokens.iris600,
        borderWidth: 0,
        color: Tokens.colorBrandNeutral100,
        marginBottom: Tokens.spacing40
    },
    chipStatusComments: {
        backgroundColor: Tokens.colorBrandNeutral100,
        borderWidth: 0,
        boxShadow: '0 0 1.25rem rgba(0, 0, 0, .1)',
        marginLeft: Tokens.sizingXLarge
    },
    commentsForStudent: {
        width: '100%'
    },
    commentsInChip: {
        paddingBottom: Tokens.spacing30,
        paddingTop: Tokens.spacing30,
        whiteSpace: 'initial',
        wordBreak: 'normal'
    },
    commentsInChipEditable: {
        '& > div > textarea': {
            width: '100%'
        },
        paddingBottom: Tokens.spacing30,
        paddingTop: Tokens.spacing30
    },
    firstIcon: {
        marginLeft: Tokens.spacing30
    },
    overrideCommentsContainer: {
        marginLeft: Tokens.sizingXLarge
    },
    secondIcon: {
        marginLeft: Tokens.spacing50
    },
    textOverChip: {
        marginLeft: Tokens.spacing34,
        wordBreak: 'normal'
    }
});
const PermissionRequestDetail = (props) => {
    const { chatTitleAdorned, classes, generalStatus, id, isFaculty, isStudent, permissionRequestInfo, resources, resourcesPermissionRequestStatus, withChatTitle, withScroll, onCancelEdit, onChangeCommentsForEdit, onEdit, onEnableEdit } = props;
    const getStatusText = (status) => {
        let text = '';
        switch (status) {
            case 0:
                text = resourcesPermissionRequestStatus.lblApproved;
                break;
            case 1:
                text = resourcesPermissionRequestStatus.lblDenied;
                break;
            case 2:
                text = resourcesPermissionRequestStatus.lblPending;
                break;
        }
        return text;
    };
    const getStatusType = (status) => {
        let type = 'default';
        switch (status) {
            case 0:
                type = 'success';
                break;
            case 1:
                type = 'error';
                break;
            case 2:
                type = 'draft';
                break;
        }
        return type;
    };
    return (React.createElement(React.Fragment, null,
        withChatTitle ? (React.createElement("div", { className: chatTitleAdorned ? classes.chatTitle : undefined },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true },
                    React.createElement(Text, { size: "h4" }, resources.lblStatusTitle)),
                React.createElement(Grid, { item: true, xs: true },
                    React.createElement(StatusLabel, { id: `lblStatusGeneral_${id}`, text: getStatusText(generalStatus), type: getStatusType(generalStatus) }))))) : undefined,
        React.createElement("div", { id: id, className: withScroll ?
                classnames(classes.chatContainer, classes.chatContainerScroll)
                : classes.chatContainer }, permissionRequestInfo.map((permissionRequest, ipr) => {
            const onChangeCommentsForEditWithId = (event) => {
                onChangeCommentsForEdit(permissionRequest.id, event.target.value);
            };
            const onClickCancelEdit = function () { onCancelEdit(permissionRequest.id); };
            const onClickEdit = function () { onEdit(permissionRequest.id); };
            const onClickEnableEdit = function () { onEnableEdit(permissionRequest.id); };
            return (React.createElement(Grid, { container: true, spacing: 0, key: `permissionRequestInfo_${ipr}` },
                React.createElement(Grid, { item: true, xs: 12 },
                    permissionRequest.studentComments || permissionRequest.studentCommentsBackup ? (React.createElement(Grid, { container: true, justifyContent: isFaculty ? 'flex-start' : 'flex-end' },
                        React.createElement(Grid, { item: true, xs: isFaculty ? true : false },
                            React.createElement(Text, { className: classes.textOverChip, color: "textSecondary", size: "small", verticalAlign: "middle" }, permissionRequest.requestDate),
                            isStudent && permissionRequest.editable ? (React.createElement(Grid, { container: true },
                                React.createElement(Grid, { item: true, xs: true },
                                    React.createElement(Chip, { classes: { root: classes.chipEditableComments }, id: "chpStudentEditableComments", label: (React.createElement(React.Fragment, null,
                                            React.createElement(TextField, { classes: { root: classes.commentsInChipEditable }, error: permissionRequest.error, helperText: permissionRequest.error ?
                                                    resources.lblCommentRequired : '', id: `txtComments_${permissionRequest.id}`, label: resources.lblComments, multiline: true, minRows: 2, type: "text", value: permissionRequest.studentComments || '', onChange: onChangeCommentsForEditWithId }),
                                            React.createElement(Link, { classes: { anchor: classes.anchorIcon }, className: classes.firstIcon, id: `btnEdit_${permissionRequest.id}`, onClick: onClickEdit },
                                                React.createElement(Tooltip, { id: `tltEdit_${permissionRequest.id}`, title: resources.btnAccept, "aria-label": resources.btnAccept },
                                                    React.createElement(Icon, { large: true, name: "check-feedback", type: "success" }))),
                                            React.createElement(Link, { classes: { anchor: classes.anchorIcon }, className: classes.secondIcon, id: `btnCancelEdit_${permissionRequest.id}`, onClick: onClickCancelEdit },
                                                React.createElement(Tooltip, { id: `tltCancelEdit_${permissionRequest.id}`, title: resources.btnCancel, "aria-label": resources.btnCancel },
                                                    React.createElement(Icon, { large: true, name: "close", type: "error" }))))) })))) : (React.createElement(Chip, { classes: { root: classes.chipImportantComments }, id: "chpStudentComments", label: (React.createElement(React.Fragment, null,
                                    React.createElement(Text, { className: classes.commentsInChip, color: "inherit", size: "small" }, permissionRequest.studentComments),
                                    isStudent && generalStatus >= 2 ? (React.createElement(Link, { classes: { anchor: classes.anchorIcon }, className: classes.firstIcon, id: `btnEnableEdit_${permissionRequest.id}`, onClick: onClickEnableEdit },
                                        React.createElement(Tooltip, { id: `tltEnableEdit_${permissionRequest.id}`, title: resources.btnEdit, "aria-label": resources.btnEdit },
                                            React.createElement(Icon, { name: "edit", type: "neutral" })))) : undefined)) }))))) : undefined,
                    permissionRequest.facultyInfo ? (React.createElement(Grid, { container: true, justifyContent: isFaculty && permissionRequest.isMyInfo ? 'flex-end' : 'flex-start' },
                        React.createElement(Grid, { item: true, xs: isFaculty && permissionRequest.isMyInfo ? false : true },
                            React.createElement(Chip, { classes: { root: classes.chipStatusComments }, id: "chpStatusPermission", label: (React.createElement(StatusLabel, { id: `lblStatus_${permissionRequest.id}_${id}`, text: getStatusText(permissionRequest.statusPermisionRequest), type: getStatusType(permissionRequest.statusPermisionRequest) })) }),
                            React.createElement("br", null),
                            React.createElement("div", { className: classes.centered },
                                React.createElement("div", null,
                                    React.createElement(Avatar, { backgroundNumber: permissionRequest.facultyInfo.colorFirstLetter }, permissionRequest.facultyInfo.firstLetter)),
                                React.createElement("div", { className: classes.commentsForStudent },
                                    React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { item: true, xs: true },
                                            React.createElement(Text, { className: classes.textOverChip, color: "textSecondary", size: "small", verticalAlign: "middle" }, permissionRequest.permissionDate ?
                                                `${permissionRequest.facultyInfo.fullName} (${permissionRequest.permissionDate})`
                                                : `${permissionRequest.facultyInfo.fullName}`))),
                                    isFaculty && permissionRequest.isMyInfo ? (permissionRequest.editable ? (React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { item: true, xs: true },
                                            React.createElement(Chip, { classes: { root: classes.chipEditableComments }, id: "chpPermissionEditableComments", label: (React.createElement(React.Fragment, null,
                                                    React.createElement(TextField, { classes: { root: classes.commentsInChipEditable }, error: permissionRequest.error, helperText: permissionRequest.error ?
                                                            resources.lblCommentRequired : '', id: `txtComments_${permissionRequest.id}`, label: resources.lblComments, multiline: true, minRows: 2, type: "text", value: permissionRequest.permissionComments || '', onChange: onChangeCommentsForEditWithId }),
                                                    React.createElement(Link, { classes: { anchor: classes.anchorIcon }, className: classes.firstIcon, id: `btnEdit_${permissionRequest.id}`, onClick: onClickEdit },
                                                        React.createElement(Tooltip, { id: `tltEdit_${permissionRequest.id}`, title: resources.btnAccept, "aria-label": resources.btnAccept },
                                                            React.createElement(Icon, { large: true, name: "check-feedback", type: "success" }))),
                                                    React.createElement(Link, { classes: { anchor: classes.anchorIcon }, className: classes.secondIcon, id: `btnCancelEdit_${permissionRequest.id}`, onClick: onClickCancelEdit },
                                                        React.createElement(Tooltip, { id: `tltCancelEdit_${permissionRequest.id}`, title: resources.btnCancel, "aria-label": resources.btnCancel },
                                                            React.createElement(Icon, { large: true, name: "close", type: "error" }))))) })))) : (React.createElement(Chip, { classes: { root: classes.chipCommonComments }, id: "chpPermissionComments", label: (React.createElement(React.Fragment, null,
                                            React.createElement(Text, { className: classes.commentsInChip, color: "inherit", component: permissionRequest.permissionComments ?
                                                    undefined : 'em', size: "small" }, permissionRequest.permissionComments || resources.lblTypeComments),
                                            !Boolean(permissionRequest.overrideId
                                                || (permissionRequest.overrideInfo
                                                    && permissionRequest.overrideInfo.fullName)) ? (React.createElement(Link, { classes: { anchor: classes.anchorIcon }, className: classes.firstIcon, id: `btnEnableEdit_${permissionRequest.id}`, onClick: onClickEnableEdit },
                                                React.createElement(Tooltip, { id: `tltEnableEdit_${permissionRequest.id}`, title: resources.btnEdit, "aria-label": resources.btnEdit },
                                                    React.createElement(Icon, { name: "edit", type: "info" })))) : undefined)) }))) : (React.createElement(React.Fragment, null,
                                        React.createElement(Chip, { classes: { root: classes.chipCommonComments }, id: "chpPermissionCommentsStudent", label: (React.createElement(Text, { className: classes.commentsInChip, color: "inherit", size: "small" }, permissionRequest.permissionComments || resources.lblNoComments)) }),
                                        React.createElement("br", null))))),
                            permissionRequest.overrideId
                                || (permissionRequest.overrideInfo
                                    && permissionRequest.overrideInfo.fullName) ? (React.createElement("div", { className: classes.overrideCommentsContainer },
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, xs: true },
                                        React.createElement(Text, { className: classes.textOverChip, color: "textSecondary", size: "small", verticalAlign: "middle" }, `${(permissionRequest.overrideInfo
                                            && permissionRequest.overrideInfo.fullName) ?
                                            permissionRequest.overrideInfo.fullName
                                            : permissionRequest.overrideId} (${permissionRequest.overrideDate})`))),
                                React.createElement(Chip, { classes: { root: classes.chipCommonComments }, id: "chpOverrideComments", label: (React.createElement(Text, { className: classes.commentsInChip, color: "inherit", size: "small" }, permissionRequest.overrideComments || resources.lblNoComments)) }),
                                React.createElement("br", null))) : undefined))) : undefined,
                    ipr < permissionRequestInfo.length - 1 ? (React.createElement(Divider, null)) : undefined)));
        }))));
};
export default withStyles(styles)(PermissionRequestDetail);
